/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormShortSummary,
    FormShortSummaryFromJSON,
    FormShortSummaryFromJSONTyped,
    FormShortSummaryToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormShortSummaryResponse
 */
export interface FormShortSummaryResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormShortSummaryResponse
     */
    msg: string;
    /**
     * 
     * @type {FormShortSummary}
     * @memberof FormShortSummaryResponse
     */
    entry: FormShortSummary;
}

export function FormShortSummaryResponseFromJSON(json: any): FormShortSummaryResponse {
    return FormShortSummaryResponseFromJSONTyped(json, false);
}

export function FormShortSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormShortSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': FormShortSummaryFromJSON(json['entry']),
    };
}

export function FormShortSummaryResponseToJSON(value?: FormShortSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': FormShortSummaryToJSON(value.entry),
    };
}


